import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            热门速递
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            实时追踪全网最热娱乐资讯，一站式浏览明星八卦、影视综艺、音乐时尚等热门内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={`吃瓜在线 - ${card.title}`}
                  title={`${card.title} - 吃瓜在线热门速递`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/50 rounded-full px-2.5 py-1">
                  <i className="ri-fire-line text-primary-400 text-xs"></i>
                  <span className="text-white text-xs">{card.heat}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6">
          <article className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer flex flex-col sm:flex-row">
            <div className="relative w-full sm:w-[280px] lg:w-[340px] aspect-[3/2] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
              <img
                src={cards[6].image}
                alt={`吃瓜在线 - ${cards[6].title}`}
                title={`${cards[6].title} - 吃瓜在线热门速递`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  {cards[6].tag}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-fire-line text-primary-500"></i>
                  {cards[6].heat}
                </span>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cards[6].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cards[6].summary}
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}